/*
 * Copyright (c) 2023. Collabro Limited
 */
import React from "react";
import { Icon } from "@mui/material";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";

const BulkBooking = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        textAlign: "center",
        width: 390,
      }}
    >
      <p style={{ opacity: "50%" }}>Coming Soon</p>
      <Icon fontSize="large" style={{ opacity: "50%" }}>
        <EventAvailableIcon />
      </Icon>
    </div>
  );
};

export default BulkBooking;
